// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608041704/js/" + chunkId + "." + {"44":"fed567bd","225":"d5efd8ba","481":"ed733621","486":"5fc7eb6e","770":"2fe58e2a"}[chunkId] + ".0.09253485598463007.chunk.js";
};